import { currentConfig } from "../constants";
import { buildEndpointUrl } from "./http-client-url-builder";

interface HttpClientSwrKeyTarget {
  endpoint: string;
  path?: Record<string, string | number>;
  query?: object;
}

export const matchSwrKey = (swrKey: string, { endpoint, path, query }: HttpClientSwrKeyTarget) => {
  const keyPath = swrKey.includes("@@") ? swrKey.slice(0, swrKey.lastIndexOf("@@")) : swrKey;

  if (!keyPath.startsWith("/")) {
    return false;
  }

  const expectedPathname = buildEndpointUrl("", endpoint, path ?? {}, {});

  const { pathname, search } = new URL(`${currentConfig.apiUrl}${keyPath}`);
  if (pathname !== expectedPathname) {
    return false;
  }

  const searchParams = new URLSearchParams(search);
  for (const [key, value] of Object.entries(query ?? {})) {
    if (searchParams.get(key) !== value.toString()) {
      return false;
    }
  }

  return true;
};
